import {
	chiliPayUserApi,
	type PutUserUserAppStoreReviewData,
	type PutUserUserAppStoreReviewPayload
} from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

export const UseAppStoreReviewQueryKey = ['app-store-review'];

export const useAppStoreReviewDisplayedQuery = () => {
	const { data, error, isPending, isSuccess, mutate, mutateAsync } = useMutation<
		PutUserUserAppStoreReviewData,
		Error,
		PutUserUserAppStoreReviewPayload
	>({
		mutationFn: async (requestData: PutUserUserAppStoreReviewPayload) =>
			(await chiliPayUserApi).putUserUserAppStoreReview(requestData),
		mutationKey: UseAppStoreReviewQueryKey
	});

	return {
		data,
		error,
		isLoading: isPending,
		isSuccess,
		mutate,
		mutateAsync
	};
};
